 export const navItems = [
    {
      label: "Home",
      link: "/",
      
    },
    {
      label: "About",
      link: "/about",
    },
    {
      label: "Services",
      link: "/services",
      
    },
    {
      label: "Career",
      link: "/career",
      
    },
    {
      label: "Contact Us",
      link: "/contact_us",
    },
  ];

 export const services = [
  {
    title: "Digital Growth & SEO",
    icon: "../assets/Icon/card1.png",
  },
  {
    title: "Web Development",
    icon: "/assets/Icon/2.svg",
  },
  {
    title: "Resource Outsourcing",
    icon: "/assets/Icon/card3.png",
  },
  {
    title: "Tailored Software Solutions",
    icon: "/assets/Icon/card4.png",
  },
  {
    title: "Upskill with Expert Trainning ",
    icon: "/assets/Icon/card5.png",
  },
];

export const servicesOffer = [
  {
    title: "iOS & Android App Development",
    img: "assets/Icon/1.png",
    desc: "Build scalable and high-performance mobile apps tailored for both iOS and Android platforms.",
  },
  {
    title: "Progressive Web App (PWA)",
    img: "assets/Icon/2.png",
    desc: "Deliver app-like experiences through web using fast, responsive, and installable PWAs.",
  },
  {
    title: "Custom Website Development",
    img: "assets/Icon/3.png",
    desc: "We create dynamic, SEO-friendly websites built with modern frameworks like React, Next.js, and Laravel.",
  },
  {
    title: "UI/UX Design Strategy",
    img: "assets/Icon/1.png",
    desc: "Design pixel-perfect, intuitive user interfaces and optimized user journeys to boost engagement.",
  },
  {
    title: "SEO & Performance Optimization",
    img: "assets/Icon/4.png",
    desc: "Increase your organic traffic and page performance with keyword-driven, technical SEO best practices.",
  },
  {
    title: "Cloud Hosting & Support",
    img: "assets/Icon/5.png",
    desc: "Deploy and scale your apps seamlessly using AWS, GCP, or Azure with 24/7 DevOps support.",
  },
];

 export const testimonials = [
      // {
      //     name: "Mahindra Logistics",
      //     // title: "Senior Developer",
      //     feedback: "A reliable tech partner that truly understands business needs. From planning to deployment, everything was handled with precision.",
      //     image: "/assets/client/cl1.webp", 
      // },
      {
          name: "Girnarsoft",
          // title: "Project Manager",
          feedback: "Great collaboration and timely execution. ITfirm’s development expertise helped us scale faster and improve performance across platforms.",
          image: "/assets/client/cl2.webp",
      },
      {
          name: "Medi Assist",
          // title: "CTO, TechnoSoft",
          feedback: "Great collaboration and timely execution. ITfirm’s development expertise helped us scale faster and improve performance across platforms.",
          image: "/assets/client/cl3.webp",
      },
  ];

export const slides = [
  {
    image: "assets/img/react.jpg",
  },
  {
    image: "assets/img/java.png",
  },
   {
    image: "assets/img/dotnet.png",
  },
];


export const servicesCard = [
  {
    title: "Managed IT Services",
    icon: "../assets/Icon/card1.png",
    image: "../assets/img/service1.avif",
    description:
      "Our goal is to propel your business forward using world-class IT cybersecurity and technology. We provide expert solutions.",
  },
  {
    title: "Web Development",
    icon: "../assets/Icon/card4.png",
    image: "../assets/img/service2.jpg",
    description:
      "Building scalable, fast, and responsive websites tailored to meet your business goals and customer needs.",
  },
  {
    title: "Resource Outsourcing",
    icon: "../assets/Icon/card3.png",
    image: "../assets/img/service3.jpg",
    description:
      "Get access to skilled developers, designers, and marketers on-demand Our flexible outsourcing solutions scale with your business needs.",
  },
  {
    title: "Digital Marketing",
    icon: "../assets/Icon/card2.png",
    image: "../assets/img/service4.jpg",
    description:
      "Reach the right audience at the right time through SEO, social media, and paid ads.",
  },
];

export const roles = [
  {
    id: 1,
    title: "QA Tester",
    openings: 5,
    experience: "2+",
    objective: "As a QA Tester, you'll play a key role in ensuring product quality by identifying bugs and verifying functionality through rigorous testing.",
    details: "Requirements include knowledge of software testing methodologies, proficiency in automation tools like Selenium, experience with bug tracking systems (e.g., Jira), and the ability to write comprehensive test cases."
  },
  {
    id: 2,
    title: "Frontend Developer",
    openings: 3,
    experience: "3+",
    objective: "As a Frontend Developer, you'll be responsible for creating interactive and responsive user interfaces that enhance the user experience.",
    details: "Candidates must have experience with React.js, strong JavaScript fundamentals, and proficiency in HTML/CSS. Familiarity with responsive design practices and frontend build tools (like Webpack, Vite) is expected."
  },
  {
    id: 3,
    title: "Backend Developer",
    openings: 2,
    experience: "1+",
    objective: "As a Backend Developer, your role is to build and maintain the server-side logic, ensuring fast performance and smooth data flow between the frontend and backend.",
    details: "You should have a solid understanding of Node.js, Express.js, RESTful API development, and working knowledge of databases like MongoDB or MySQL. Familiarity with authentication, error handling, and deployment processes is also important."
  }
];

